var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseSearchBigImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.776,
    height: 9.429,
    viewBox: "0 0 13.776 9.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.482,
    y1: 1.105,
    x2: 0.508,
    y2: -0.183,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.922,
    y1: -0.287,
    x2: -0.361,
    y2: 2.167,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: -11.018,
    x2: 0.5,
    y2: -0.015,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.874,
    y1: -0.354,
    x2: -0.413,
    y2: 2.582,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.988,
    y1: -2.841,
    x2: -0.479,
    y2: 2.651,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 37.011,
    y1: 48.326,
    x2: 38.011,
    y2: 48.326,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1.257,
    y1: -1.365,
    x2: -0.581,
    y2: 3.163,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.936,
    y1: -0.078,
    x2: -0.19,
    y2: 1.416,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1.214,
    y1: -0.449,
    x2: -0.632,
    y2: 2.003,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.569,
    y1: 1.919,
    x2: -5.335,
    y2: 8.247,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -771.351,
    y1: 21.574,
    x2: -779.351,
    y2: 22.432,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -70.857,
    y1: 113.207,
    x2: -71.158,
    y2: 117.948,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -46.88,
    y1: 77.263,
    x2: -47.322,
    y2: 80.482,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.874,
    y1: -0.354,
    x2: -0.413,
    y2: 2.582,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1.988,
    y1: -2.841,
    x2: -0.479,
    y2: 2.651,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 35.25,
    y1: 50.461,
    x2: 36.25,
    y2: 50.461,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1.257,
    y1: -1.365,
    x2: -0.581,
    y2: 3.163,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 32.991,
    y1: 52.192,
    x2: 33.994,
    y2: 52.192,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.879,
    y1: -0.35,
    x2: -0.423,
    y2: 2.573,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1.988,
    y1: -2.841,
    x2: -0.479,
    y2: 2.651,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 30.782,
    y1: 55.182,
    x2: 31.782,
    y2: 55.182,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1.988,
    y1: -2.841,
    x2: -0.479,
    y2: 2.651,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 28.328,
    y1: 58.13,
    x2: 29.331,
    y2: 58.13,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1.257,
    y1: -1.365,
    x2: -0.581,
    y2: 3.163,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 0.533,
    y1: -0.195,
    x2: 0.587,
    y2: -1.321,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0.746,
    y1: -0.181,
    x2: 0.226,
    y2: 1.259,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42234",
    "data-name": "Group 42234",
    transform: "translate(-3096.166 1006.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82448",
    "data-name": "Path 82448",
    d: "M3209.009-894.511c-.743-.387.519-1.516-.568-2.226a2.78,2.78,0,0,0-3.681.757c-.928,1.049-1.089,2.166-3.663.507s-3.527,1.3-2.749,2.115.387.826-.1,2.235,1.417,2.407,3.07,1.53,1.426-.968,3.616-.051,3.778-.184,5.16-1.178C3212.85-892.8,3209.752-894.124,3209.009-894.511Z",
    transform: "translate(-101.274 -108.895)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42181",
    "data-name": "Group 42181",
    transform: "translate(3107.592 -1000.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42176",
    "data-name": "Group 42176",
    transform: "translate(0 0.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82449",
    "data-name": "Path 82449",
    d: "M5198.506,290.715a.009.009,0,0,1-.007,0,.009.009,0,0,1,0-.013l.028-.024a.009.009,0,0,1,.013,0,.01.01,0,0,1,0,.013l-.028.024Z",
    transform: "translate(-5196.613 -289.614)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82450",
    "data-name": "Path 82450",
    d: "M4902.2,149.083a.009.009,0,0,1-.009-.009.009.009,0,0,1,.009-.01l.071,0a.009.009,0,1,1,0,.018l-.072,0Zm-.117,0h0l-.072-.007a.009.009,0,0,1-.008-.01.01.01,0,0,1,.011-.008l.071.007a.009.009,0,0,1,.009.01A.009.009,0,0,1,4902.081,149.081Zm.3-.02a.009.009,0,0,1-.009-.007.009.009,0,0,1,.007-.011l.069-.016a.009.009,0,0,1,.011.007.009.009,0,0,1-.006.011l-.071.017Zm-.49-.008h0l-.07-.019a.009.009,0,0,1-.006-.012.009.009,0,0,1,.011-.006l.069.019a.009.009,0,0,1,.007.011A.009.009,0,0,1,4901.895,149.053Zm.672-.044a.009.009,0,0,1-.009-.006.009.009,0,0,1,.005-.012l.006,0,.06-.025a.009.009,0,1,1,.007.017l-.061.025-.006,0Zm-.851-.014h0l-.066-.03a.009.009,0,0,1,0-.012.009.009,0,0,1,.012,0l.065.03a.009.009,0,0,1,0,.018Zm1.021-.067a.009.009,0,0,1-.008,0,.009.009,0,0,1,0-.013l.061-.038a.009.009,0,0,1,.01.015l-.062.038Zm-1.188-.02h0l-.061-.04a.01.01,0,0,1,0-.013.009.009,0,0,1,.013,0l.06.04a.009.009,0,0,1,0,.013A.01.01,0,0,1,4901.548,148.908Zm-.151-.113-.006,0c-.018-.016-.036-.033-.053-.05a.009.009,0,0,1,0-.013.009.009,0,0,1,.013,0c.017.017.034.033.052.049a.009.009,0,0,1,0,.013A.01.01,0,0,1,4901.4,148.8Zm-.13-.136a.01.01,0,0,1-.007,0c-.015-.019-.03-.038-.044-.058a.009.009,0,0,1,0-.013.009.009,0,0,1,.013,0c.014.019.028.038.043.057a.01.01,0,0,1,0,.013Zm-.106-.155a.01.01,0,0,1-.008,0c-.012-.021-.023-.042-.034-.064a.009.009,0,0,1,.017-.008c.01.021.022.042.033.063a.009.009,0,0,1,0,.013Zm-.08-.171a.009.009,0,0,1-.009-.006c-.008-.023-.016-.046-.023-.069a.009.009,0,0,1,.006-.012.009.009,0,0,1,.012.006c.007.023.015.045.023.068a.01.01,0,0,1-.006.012Zm-.051-.182a.009.009,0,0,1-.009-.007c0-.024-.009-.048-.012-.072a.009.009,0,0,1,.008-.01.009.009,0,0,1,.01.008c0,.024.007.047.012.07a.009.009,0,0,1-.007.011Zm-.021-.187a.009.009,0,0,1-.009-.009c0-.01,0-.021,0-.031s0-.028,0-.041a.009.009,0,0,1,.009-.009h0a.01.01,0,0,1,.009.01c0,.013,0,.027,0,.041s0,.02,0,.031a.009.009,0,0,1-.009.01Z",
    transform: "translate(-4900.999 -147.72)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82451",
    "data-name": "Path 82451",
    d: "M4902.74,123.659h0a.01.01,0,0,1-.008-.01l.006-.037a.009.009,0,0,1,.011-.008.009.009,0,0,1,.007.011c0,.012,0,.024-.005.036A.009.009,0,0,1,4902.74,123.659Z",
    transform: "translate(-4902.72 -123.604)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42177",
    "data-name": "Group 42177",
    transform: "translate(0.466 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82452",
    "data-name": "Path 82452",
    d: "M4974.543,4.912a.009.009,0,0,1-.005-.017l.03-.022a.009.009,0,0,1,.013,0,.009.009,0,0,1,0,.013l-.03.021Z",
    transform: "translate(-4974.534 -4.667)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82453",
    "data-name": "Path 82453",
    d: "M4997.606-26.16h0a.009.009,0,0,1-.009-.01c0-.025,0-.05,0-.075a.009.009,0,0,1,.009-.009h0a.009.009,0,0,1,.009.009c0,.025,0,.051,0,.076A.009.009,0,0,1,4997.606-26.16Zm0-.2a.009.009,0,0,1-.009-.008c0-.025-.006-.05-.01-.075a.009.009,0,0,1,.008-.011.009.009,0,0,1,.01.008c0,.025.008.051.01.076a.009.009,0,0,1-.008.01Zm-.037-.2a.009.009,0,0,1-.009-.007c-.007-.024-.015-.048-.023-.072a.01.01,0,0,1,.006-.012.009.009,0,0,1,.012.006c.008.024.016.049.023.073a.009.009,0,0,1-.006.011Zm-.07-.187a.009.009,0,0,1-.008-.005c-.011-.023-.022-.045-.034-.067a.009.009,0,0,1,0-.013.009.009,0,0,1,.013,0c.012.022.024.045.035.068a.009.009,0,0,1,0,.012Zm-.1-.172a.009.009,0,0,1-.007,0c-.015-.02-.03-.041-.045-.06a.009.009,0,0,1,0-.013.009.009,0,0,1,.013,0c.016.02.032.04.046.061a.009.009,0,0,1,0,.013Zm-.128-.152a.01.01,0,0,1-.007,0c-.018-.018-.036-.035-.055-.051a.009.009,0,0,1,0-.013.009.009,0,0,1,.013,0c.02.017.038.034.056.052a.009.009,0,0,1,0,.013A.008.008,0,0,1,4997.269-27.065Zm-.153-.127-.005,0c-.021-.014-.042-.028-.063-.041a.01.01,0,0,1,0-.013.009.009,0,0,1,.013,0c.022.013.043.027.064.042a.009.009,0,0,1,0,.013A.01.01,0,0,1,4997.115-27.192Zm-1.207-.066a.01.01,0,0,1-.008,0,.009.009,0,0,1,0-.013l.068-.034a.009.009,0,0,1,.012,0,.009.009,0,0,1,0,.012l-.067.034Zm1.034-.033h0l-.069-.029a.009.009,0,0,1,0-.012.009.009,0,0,1,.012-.005c.024.009.047.019.07.03a.009.009,0,0,1,0,.012A.01.01,0,0,1,4996.942-27.291Zm-.851-.047a.009.009,0,0,1-.009-.006.009.009,0,0,1,.006-.012l.073-.022a.009.009,0,0,1,.011.007.009.009,0,0,1-.006.011l-.072.022Zm.664-.021h0l-.073-.017a.009.009,0,0,1-.007-.011.009.009,0,0,1,.011-.007l.075.017a.009.009,0,0,1,.006.011A.009.009,0,0,1,4996.755-27.359Zm-.471-.026a.01.01,0,0,1-.009-.008.01.01,0,0,1,.008-.011l.076-.009a.009.009,0,0,1,.01.008.009.009,0,0,1-.008.01l-.075.009Zm.275-.009h0l-.075,0a.009.009,0,0,1-.009-.009.01.01,0,0,1,.01-.009l.076,0a.009.009,0,0,1,.008.01A.009.009,0,0,1,4996.56-27.393Z",
    transform: "translate(-4995.764 27.416)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82454",
    "data-name": "Path 82454",
    d: "M5260.286,187.6h0a.009.009,0,0,1-.007-.011l.007-.036a.009.009,0,1,1,.018,0l-.007.037A.009.009,0,0,1,5260.286,187.6Z",
    transform: "translate(-5258.467 -186.18)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42180",
    "data-name": "Group 42180",
    transform: "translate(0.282 0.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42178",
    "data-name": "Group 42178",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82455",
    "data-name": "Path 82455",
    d: "M4947.235,20.076a.014.014,0,0,0,0-.016l-.12-.118a.738.738,0,0,0,.014-.237l.132-.1a.014.014,0,0,0,0-.015l-.066-.19a.014.014,0,0,0-.013-.009h-.168a.734.734,0,0,0-.158-.177l.02-.167a.014.014,0,0,0-.008-.014l-.182-.088a.013.013,0,0,0-.016,0l-.119.119a.729.729,0,0,0-.236-.014l-.1-.132a.013.013,0,0,0-.015,0l-.19.066a.014.014,0,0,0-.009.013v.168a.73.73,0,0,0-.177.158l-.167-.02a.014.014,0,0,0-.014.008l-.088.182a.014.014,0,0,0,0,.016l.119.118a.725.725,0,0,0-.013.237l-.132.1a.014.014,0,0,0,0,.015l.067.19a.013.013,0,0,0,.013.009h.168a.736.736,0,0,0,.158.177l-.02.167a.014.014,0,0,0,.007.014l.182.088a.014.014,0,0,0,.016,0l.118-.119a.733.733,0,0,0,.237.014l.1.132a.014.014,0,0,0,.016,0l.19-.066a.013.013,0,0,0,.009-.013V20.4a.728.728,0,0,0,.177-.158l.167.02a.014.014,0,0,0,.014-.008Z",
    transform: "translate(-4945.524 -18.913)",
    fill: "#bdd0fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42179",
    "data-name": "Group 42179",
    transform: "translate(0.681 0.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82456",
    "data-name": "Path 82456",
    d: "M5053.323,126.9a.19.19,0,0,1-.158-.085.188.188,0,0,1-.027-.141.188.188,0,0,1,.341-.066.188.188,0,0,1-.157.292Zm0-.358a.17.17,0,0,0-.142.263.17.17,0,1,0,.283-.187.17.17,0,0,0-.142-.076Z",
    transform: "translate(-5053.134 -126.522)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82457",
    "data-name": "Path 82457",
    d: "M5004.444,78.68a.5.5,0,0,1-.468-.332.489.489,0,0,1-.028-.163.5.5,0,0,1,.963-.164.481.481,0,0,1,.023.094v.009h0a.009.009,0,0,1-.019,0,.494.494,0,0,0-.023-.1.477.477,0,1,0-.084.463.009.009,0,0,1,.013,0,.009.009,0,0,1,0,.007.01.01,0,0,1,0,.006.5.5,0,0,1-.38.178Z",
    transform: "translate(-5003.578 -77.316)",
    fill: "#91b3fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42182",
    "data-name": "Group 42182",
    transform: "translate(3096.166 -1000.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82458",
    "data-name": "Path 82458",
    d: "M3096.176-62.009a.028.028,0,0,1,.021-.05,2.017,2.017,0,0,1,1.541,1.025c.659,1.076,1.147,1.272,1.575,1.288a1.4,1.4,0,0,1-.939-.014C3097.126-60.224,3096.549-61.7,3096.176-62.009Z",
    transform: "translate(-3096.166 62.059)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82459",
    "data-name": "Path 82459",
    d: "M3154.877-23.018a1.13,1.13,0,0,1,.152.091l.018.012.018.013.036.026.069.055a2.947,2.947,0,0,1,.258.242c.082.084.157.176.231.267l.054.07.027.035.013.018.013.018.1.144a3.567,3.567,0,0,0,.452.529q.125.122.26.232l.068.054.069.053.071.051.072.048h0a.028.028,0,0,1,.008.038.027.027,0,0,1-.037.009c-.052-.032-.1-.065-.148-.1l-.071-.053-.07-.055c-.092-.074-.18-.153-.265-.235-.043-.041-.083-.084-.124-.126l-.059-.066-.03-.033-.029-.034-.056-.068c-.019-.023-.036-.047-.054-.07l-.027-.035-.013-.018-.013-.018-.051-.073-.05-.072-.049-.072-.012-.018-.013-.018-.026-.035-.052-.071-.054-.069c-.018-.023-.036-.046-.055-.068l-.056-.067-.029-.033-.029-.033a2.935,2.935,0,0,0-.247-.247l-.066-.057-.034-.027-.017-.014-.018-.013-.035-.026-.036-.025c-.024-.016-.049-.032-.074-.045h0a.007.007,0,0,1,0-.01A.007.007,0,0,1,3154.877-23.018Z",
    transform: "translate(-3154.495 23.266)",
    fill: "#fff",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42183",
    "data-name": "Group 42183",
    transform: "translate(3096.949 -1001.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82460",
    "data-name": "Path 82460",
    d: "M3219.842-208.442c.119.425.91,3.024,2.569,3.265a.068.068,0,0,0,.074-.089,5.153,5.153,0,0,0-1.5-2.143c-.73-.64-1.026-.942-1.123-1.047A.014.014,0,0,0,3219.842-208.442Z",
    transform: "translate(-3219.841 208.46)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82461",
    "data-name": "Path 82461",
    d: "M3303.467-78.934a.016.016,0,0,1-.01,0,10.386,10.386,0,0,1-1.5-1.535,6.939,6.939,0,0,1-.614-.85.016.016,0,0,1,.014-.017.016.016,0,0,1,.017.012,10.865,10.865,0,0,0,2.106,2.365.016.016,0,0,1,0,.022A.015.015,0,0,1,3303.467-78.934Zm-2.1-2.391h0Z",
    transform: "translate(-3300.823 82.144)",
    fill: "#fff",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42184",
    "data-name": "Group 42184",
    transform: "translate(3106.9 -1005.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82462",
    "data-name": "Path 82462",
    d: "M4791.639-826.057a1.662,1.662,0,0,0,1.147-.923c.39-.79.743-1.954,1.779-2.012a.04.04,0,0,1,.033.066,4.063,4.063,0,0,0-.647,1.078C4793.71-827.212,4792.81-825.806,4791.639-826.057Z",
    transform: "translate(-4791.639 828.992)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82463",
    "data-name": "Path 82463",
    d: "M4886.538-792.39h0l-.005,0-.012,0-.024.011-.046.024a.972.972,0,0,0-.088.057c-.028.02-.056.042-.082.065s-.052.047-.077.072a1.438,1.438,0,0,0-.243.344,1.651,1.651,0,0,0-.084.194l-.018.05-.016.051-.016.051c-.005.017-.011.034-.017.051a3.252,3.252,0,0,1-.164.4l-.024.048-.025.048-.025.047c-.009.016-.017.032-.026.047-.036.063-.074.124-.113.184s-.082.118-.125.175-.09.112-.138.166-.1.1-.15.154-.107.1-.164.139a1.739,1.739,0,0,1-.178.121,1.55,1.55,0,0,1-.192.1,1.534,1.534,0,0,0,.189-.1,1.708,1.708,0,0,0,.174-.125q.083-.067.16-.142t.146-.156q.07-.081.133-.167c.042-.058.083-.116.121-.176s.075-.121.109-.184c.009-.015.017-.031.025-.047s.017-.031.025-.047l.024-.048.023-.048a3.149,3.149,0,0,0,.156-.4c.006-.017.011-.034.016-.051l.016-.051.016-.052.018-.051a1.763,1.763,0,0,1,.085-.2,1.479,1.479,0,0,1,.111-.187,1.356,1.356,0,0,1,.139-.168,1.154,1.154,0,0,1,.166-.142.992.992,0,0,1,.093-.058l.024-.013.025-.012.025-.011.013-.005.007,0h.008a.021.021,0,0,1,.026.014.022.022,0,0,1-.014.026Z",
    transform: "translate(-4883.895 792.663)",
    fill: "#fff",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42185",
    "data-name": "Group 42185",
    transform: "translate(3107.128 -1003.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82464",
    "data-name": "Path 82464",
    d: "M4830.4-537.076a.022.022,0,0,0-.009-.041,1.56,1.56,0,0,0-1.31.576c-.645.732-1.043.816-1.371.772a1.083,1.083,0,0,0,.717.114C4829.443-535.842,4830.078-536.886,4830.4-537.076Z",
    transform: "translate(-4827.714 537.121)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82465",
    "data-name": "Path 82465",
    d: "M4923.616-513.958c-.021.007-.042.016-.062.025l-.031.014-.03.015-.015.008-.015.008-.03.016-.058.034a2.368,2.368,0,0,0-.221.155l-.026.021-.026.021-.052.043c-.018.014-.034.03-.051.045l-.05.045-.048.047-.024.023-.012.012-.012.012-.047.049-.047.049-.048.049-.012.012-.013.012-.025.023-.051.046-.052.044-.026.022-.027.021-.054.042c-.037.027-.073.054-.111.08-.076.051-.153.1-.233.144l-.061.032-.061.031c-.042.02-.083.039-.126.056a.021.021,0,0,1-.027-.012.021.021,0,0,1,.011-.027h0l.061-.027.061-.029.06-.031.059-.032q.118-.066.229-.142a2.76,2.76,0,0,0,.415-.343l.1-.1.012-.012.013-.012.025-.023.05-.046c.068-.06.138-.119.211-.173a2.362,2.362,0,0,1,.229-.15l.061-.032.031-.015.015-.008.016-.007a.87.87,0,0,1,.128-.049.005.005,0,0,1,.007,0,.005.005,0,0,1,0,.007Z",
    transform: "translate(-4921.232 514.116)",
    fill: "#fff",
    opacity: 0.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42188",
    "data-name": "Group 42188",
    transform: "translate(3098.428 -1003.873)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42187",
    "data-name": "Group 42187",
    transform: "translate(0.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82466",
    "data-name": "Path 82466",
    d: "M3529.65-544.736a.151.151,0,0,1-.15.15h-8.143a.151.151,0,0,1-.151-.15l-.068-4.68a.262.262,0,0,1,.276-.232l7.958-.206a.38.38,0,0,1,.278.111.379.379,0,0,1,.112.277Z",
    transform: "translate(-3521.138 549.854)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82467",
    "data-name": "Path 82467",
    d: "M3562.2-516.873a.143.143,0,0,1-.143.142h-7.806a.143.143,0,0,1-.143-.142l-.064-4.248a.351.351,0,0,1,.368-.342l7.627-.2a.267.267,0,0,1,.2.078.266.266,0,0,1,.078.2Z",
    transform: "translate(-3553.834 521.847)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42186",
    "data-name": "Group 42186",
    transform: "translate(0.314 0.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82468",
    "data-name": "Path 82468",
    d: "M3574.985-142.109a.011.011,0,0,1-.011-.011l-.005-.345a.011.011,0,0,1,.011-.011h0a.011.011,0,0,1,.011.011l.005.345a.011.011,0,0,1-.01.011Z",
    transform: "translate(-3574.943 144.645)",
    fill: "#fff",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82469",
    "data-name": "Path 82469",
    d: "M3570.78-483.563a.011.011,0,0,1-.011-.011l-.019-1.319a.278.278,0,0,1,.08-.209.383.383,0,0,1,.254-.088l2.436-.065a.011.011,0,0,1,.011.01.011.011,0,0,1-.01.011l-2.436.065a.36.36,0,0,0-.239.082.257.257,0,0,0-.074.193l.019,1.319a.011.011,0,0,1-.01.011Z",
    transform: "translate(-3570.75 485.255)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82470",
    "data-name": "Path 82470",
    d: "M3616-467.009c.008-.351.005-3.46-.015-3.729s.4-.319,1.04-.349,6.06-.15,6.2-.161c.313-.025.378.443.347,1.461-.024.764-.063,2.023-.081,2.6a.32.32,0,0,1-.319.31c-1.3,0-6.3.018-6.633.028C3616.154-466.836,3615.994-466.87,3616-467.009Z",
    transform: "translate(-3615.382 471.746)",
    fill: "#fff",
    opacity: 0.37
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22856",
    "data-name": "Rectangle 22856",
    width: 9.6,
    height: 0.411,
    rx: 0.206,
    transform: "translate(0 5.245)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42194",
    "data-name": "Group 42194",
    transform: "translate(3097.34 -1005.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42189",
    "data-name": "Group 42189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22857",
    "data-name": "Rectangle 22857",
    width: 3.666,
    height: 3.811,
    rx: 1.833,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22858",
    "data-name": "Rectangle 22858",
    width: 3.319,
    height: 3.598,
    rx: 1.66,
    transform: "translate(0.177 0.112)",
    fill: "#bdd0fb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22859",
    "data-name": "Rectangle 22859",
    width: 2.191,
    height: 0.228,
    rx: 0.114,
    transform: "translate(0.288 0.213)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42190",
    "data-name": "Group 42190",
    transform: "translate(2.587 0.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82471",
    "data-name": "Path 82471",
    d: "M3690.379-837.992a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,3690.379-837.992Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,3690.379-838.144Z",
    transform: "translate(-3690.286 838.168)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82472",
    "data-name": "Path 82472",
    d: "M3740.338-837.992a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,3740.338-837.992Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,3740.338-838.144Z",
    transform: "translate(-3739.928 838.168)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82473",
    "data-name": "Path 82473",
    d: "M3790.3-837.992a.091.091,0,0,1-.094-.088.091.091,0,0,1,.094-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,3790.3-837.992Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.066.066,0,0,0,.069-.064A.066.066,0,0,0,3790.3-838.144Z",
    transform: "translate(-3789.571 838.168)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82474",
    "data-name": "Path 82474",
    d: "M3341.329-831.9h-1.944a.048.048,0,0,1-.048-.048.048.048,0,0,1,.048-.048h1.944a.048.048,0,0,1,.048.048A.048.048,0,0,1,3341.329-831.9Z",
    transform: "translate(-3338.972 832.279)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42191",
    "data-name": "Group 42191",
    transform: "translate(0.177 0.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82475",
    "data-name": "Path 82475",
    d: "M3309.827-805.7l-.22.224a.023.023,0,0,0,0,.033h0a.021.021,0,0,0,.03,0l.2-.243Z",
    transform: "translate(-3309.601 806.004)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 0.145,
    cy: 0.143,
    rx: 0.145,
    ry: 0.143,
    transform: "translate(0.128 0.125) rotate(-25.513)",
    opacity: 0.2,
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82476",
    "data-name": "Path 82476",
    d: "M3334.856-849.29a.16.16,0,0,0-.078.213.161.161,0,0,0,.215.074.16.16,0,0,0,.078-.213A.16.16,0,0,0,3334.856-849.29Zm.127.266a.137.137,0,0,1-.183-.063.137.137,0,0,1,.066-.182.137.137,0,0,1,.183.063A.137.137,0,0,1,3334.983-849.024Z",
    transform: "translate(-3334.604 849.338)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82477",
    "data-name": "Path 82477",
    d: "M3353.426-729.695h-2.7a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.7a.056.056,0,0,1,.056.056A.056.056,0,0,1,3353.426-729.695Z",
    transform: "translate(-3350.233 730.735)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82478",
    "data-name": "Path 82478",
    d: "M3414.445-764.7h-1.879a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.879a.056.056,0,0,1,.056.056A.056.056,0,0,1,3414.445-764.7Z",
    transform: "translate(-3411.682 765.514)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42193",
    "data-name": "Group 42193",
    transform: "translate(0.499 1.221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22860",
    "data-name": "Rectangle 22860",
    width: 2.699,
    height: 2.253,
    rx: 1.127,
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42192",
    "data-name": "Group 42192",
    transform: "translate(0.173 0.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82479",
    "data-name": "Path 82479",
    d: "M3390.631-666.642H3388.4a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3390.631-666.642Z",
    transform: "translate(-3388.344 666.754)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82480",
    "data-name": "Path 82480",
    d: "M3390.309-632.809h-2.227a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3390.309-632.809Z",
    transform: "translate(-3388.025 633.135)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82481",
    "data-name": "Path 82481",
    d: "M3391.321-596.841h-2.227a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3391.321-596.841Z",
    transform: "translate(-3389.03 597.395)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82482",
    "data-name": "Path 82482",
    d: "M3391-563.008h-2.227a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056H3391a.056.056,0,0,1,.056.056A.056.056,0,0,1,3391-563.008Z",
    transform: "translate(-3388.711 563.776)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82483",
    "data-name": "Path 82483",
    d: "M3390.458-532.075h-2.227a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3390.458-532.075Z",
    transform: "translate(-3388.172 533.039)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82484",
    "data-name": "Path 82484",
    d: "M3390.136-498.242h-2.227a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3390.136-498.242Z",
    transform: "translate(-3387.853 499.42)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82485",
    "data-name": "Path 82485",
    d: "M3391.147-462.274h-2.227a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3391.147-462.274Z",
    transform: "translate(-3388.857 463.68)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82486",
    "data-name": "Path 82486",
    d: "M3390.826-428.441H3388.6a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3390.826-428.441Z",
    transform: "translate(-3388.539 430.061)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82487",
    "data-name": "Path 82487",
    d: "M3390.125-396.469H3387.9a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3390.125-396.469Z",
    transform: "translate(-3387.842 398.291)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82488",
    "data-name": "Path 82488",
    d: "M3391.136-360.5h-2.227a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.227a.056.056,0,0,1,.056.056A.056.056,0,0,1,3391.136-360.5Z",
    transform: "translate(-3388.847 362.551)",
    fill: "#bdd0fb",
    opacity: 0.43
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42200",
    "data-name": "Group 42200",
    transform: "translate(3105.382 -1006.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42198",
    "data-name": "Group 42198",
    transform: "translate(0 0.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82489",
    "data-name": "Path 82489",
    d: "M4602.147-919.057a.015.015,0,0,1-.015-.015.015.015,0,0,1,.015-.015h.042a.015.015,0,0,1,.016.015.015.015,0,0,1-.015.016Zm-.043,0h-.043a.016.016,0,0,1-.015-.016.015.015,0,0,1,.016-.015h.042a.016.016,0,0,1,.015.016A.016.016,0,0,1,4602.1-919.058Zm.128,0a.015.015,0,0,1-.015-.014.015.015,0,0,1,.014-.016l.042,0a.015.015,0,0,1,.017.014.015.015,0,0,1-.014.017l-.043,0Zm-.214,0h0l-.043,0a.015.015,0,0,1-.014-.017.015.015,0,0,1,.017-.014l.042,0a.015.015,0,0,1,.014.016A.015.015,0,0,1,4602.019-919.061Zm.3-.007a.015.015,0,0,1-.015-.013.015.015,0,0,1,.013-.017l.042-.006a.016.016,0,0,1,.018.013.015.015,0,0,1-.013.017l-.042.006Zm-.384,0h0l-.043-.006a.015.015,0,0,1-.013-.017.015.015,0,0,1,.017-.013l.042.006a.015.015,0,0,1,.013.017A.016.016,0,0,1,4601.934-919.07Zm.469-.011a.015.015,0,0,1-.015-.013.015.015,0,0,1,.012-.018l.042-.008a.015.015,0,0,1,.018.012.015.015,0,0,1-.012.018l-.042.008Zm-.554,0h0l-.042-.008a.015.015,0,0,1-.012-.018.015.015,0,0,1,.018-.012l.042.008a.015.015,0,0,1,.012.018A.015.015,0,0,1,4601.849-919.083Zm.638-.015a.015.015,0,0,1-.015-.012.015.015,0,0,1,.011-.018l.042-.01a.015.015,0,0,1,.019.011.016.016,0,0,1-.011.019l-.042.01Zm-.721,0h0l-.042-.011a.016.016,0,0,1-.011-.019.016.016,0,0,1,.019-.011l.041.01a.015.015,0,0,1,.011.018A.015.015,0,0,1,4601.766-919.1Zm.8-.019a.016.016,0,0,1-.015-.011.015.015,0,0,1,.01-.019l.041-.012a.015.015,0,0,1,.02.01.016.016,0,0,1-.01.019l-.042.013Zm-.887,0h0l-.041-.013a.015.015,0,0,1-.01-.019.015.015,0,0,1,.019-.01l.041.013a.015.015,0,0,1,.01.019A.015.015,0,0,1,4601.683-919.123Zm.969-.023a.015.015,0,0,1-.014-.01.015.015,0,0,1,.009-.019l.04-.015a.016.016,0,0,1,.02.009.015.015,0,0,1-.009.02l-.041.015Zm-1.05,0h0l-.041-.015a.016.016,0,0,1-.009-.02.015.015,0,0,1,.02-.009l.04.015a.015.015,0,0,1,.009.02A.016.016,0,0,1,4601.6-919.15Zm1.13-.026a.015.015,0,0,1-.014-.009.015.015,0,0,1,.008-.02l.039-.017a.016.016,0,0,1,.021.008.016.016,0,0,1-.008.02l-.04.017Zm-1.21-.005h-.006l-.04-.018a.015.015,0,0,1-.007-.02.015.015,0,0,1,.02-.008l.039.017a.016.016,0,0,1,.008.02A.015.015,0,0,1,4601.521-919.181Zm1.288-.03a.015.015,0,0,1-.014-.009.015.015,0,0,1,.007-.02l.038-.019a.015.015,0,0,1,.021.007.015.015,0,0,1-.006.021l-.039.019Zm-1.366-.006-.007,0-.039-.02a.015.015,0,0,1-.006-.021.015.015,0,0,1,.021-.006l.038.019a.015.015,0,0,1,.007.02A.016.016,0,0,1,4601.443-919.217Zm1.442-.033a.016.016,0,0,1-.014-.008.016.016,0,0,1,.006-.021l.037-.021a.015.015,0,0,1,.021.005.015.015,0,0,1-.005.021l-.038.021Zm-1.518-.007-.007,0-.038-.022a.015.015,0,0,1,0-.021.015.015,0,0,1,.021-.005l.037.021a.016.016,0,0,1,.006.021A.016.016,0,0,1,4601.367-919.257Zm1.592-.036a.015.015,0,0,1-.013-.007.016.016,0,0,1,0-.021l.036-.023a.016.016,0,0,1,.021,0,.016.016,0,0,1,0,.021l-.037.023Zm-1.665-.008-.008,0-.036-.024a.015.015,0,0,1,0-.021.016.016,0,0,1,.021,0l.035.023a.015.015,0,0,1,0,.021A.015.015,0,0,1,4601.294-919.3Zm1.736-.039a.015.015,0,0,1-.013-.007.015.015,0,0,1,0-.021l.034-.025a.015.015,0,0,1,.021,0,.016.016,0,0,1,0,.021l-.035.025Zm-1.808-.009a.015.015,0,0,1-.009,0l-.035-.026a.015.015,0,0,1,0-.021.015.015,0,0,1,.021,0l.034.025a.015.015,0,0,1,0,.021A.015.015,0,0,1,4601.223-919.349Zm1.876-.042a.015.015,0,0,1-.012-.006.015.015,0,0,1,0-.021l.033-.027a.016.016,0,0,1,.022,0,.015.015,0,0,1,0,.022l-.034.027A.016.016,0,0,1,4603.1-919.392Zm-1.944-.009a.015.015,0,0,1-.009,0l-.034-.028a.015.015,0,0,1,0-.022.015.015,0,0,1,.021,0l.033.027a.016.016,0,0,1,0,.022A.015.015,0,0,1,4601.154-919.4Zm2.01-.045a.014.014,0,0,1-.011-.005.015.015,0,0,1,0-.022l.032-.028a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.022l-.032.029A.016.016,0,0,1,4603.165-919.446Zm-2.075-.01a.015.015,0,0,1-.01,0l-.032-.029a.015.015,0,0,1,0-.022.016.016,0,0,1,.022,0l.031.029a.016.016,0,0,1,0,.022A.015.015,0,0,1,4601.089-919.456Zm2.138-.048a.016.016,0,0,1-.011,0,.015.015,0,0,1,0-.022l.03-.03a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.022l-.03.031A.016.016,0,0,1,4603.228-919.5Zm-2.2-.011a.015.015,0,0,1-.011,0l-.03-.031a.016.016,0,0,1,0-.022.016.016,0,0,1,.022,0l.029.03a.015.015,0,0,1,0,.022A.015.015,0,0,1,4601.027-919.515Zm2.26-.051a.016.016,0,0,1-.01,0,.016.016,0,0,1,0-.022l.028-.032a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.022l-.028.032A.016.016,0,0,1,4603.287-919.566Zm-2.318-.011a.016.016,0,0,1-.012-.005l-.028-.033a.015.015,0,0,1,0-.022.015.015,0,0,1,.021,0l.028.032a.015.015,0,0,1,0,.022A.016.016,0,0,1,4600.968-919.578Zm2.375-.054a.016.016,0,0,1-.01,0,.015.015,0,0,1,0-.022l.026-.033a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.027.034A.015.015,0,0,1,4603.343-919.631Zm-2.43-.012a.015.015,0,0,1-.012-.006l-.027-.034a.016.016,0,0,1,0-.021.015.015,0,0,1,.021,0l.026.033a.016.016,0,0,1,0,.022A.016.016,0,0,1,4600.913-919.643Zm2.483-.056a.016.016,0,0,1-.009,0,.015.015,0,0,1,0-.021l.025-.035a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.025.035A.015.015,0,0,1,4603.4-919.7Zm-2.535-.012a.015.015,0,0,1-.012-.006l-.025-.035a.015.015,0,0,1,0-.021.015.015,0,0,1,.021,0l.024.035a.015.015,0,0,1,0,.021A.016.016,0,0,1,4600.861-919.711Zm2.583-.058-.008,0a.016.016,0,0,1,0-.021l.023-.036a.015.015,0,0,1,.021-.005.016.016,0,0,1,0,.021l-.023.037A.015.015,0,0,1,4603.444-919.769Zm-2.631-.012a.015.015,0,0,1-.013-.007l-.023-.037a.015.015,0,0,1,.005-.021.015.015,0,0,1,.021.005l.022.036a.015.015,0,0,1,0,.021Zm2.676-.061-.007,0a.015.015,0,0,1-.006-.021l.021-.037a.016.016,0,0,1,.021-.006.016.016,0,0,1,.006.021l-.021.038A.015.015,0,0,1,4603.489-919.843Zm-2.72-.013a.015.015,0,0,1-.013-.008c-.007-.013-.014-.025-.021-.038a.015.015,0,0,1,.006-.021.015.015,0,0,1,.021.006l.02.037a.015.015,0,0,1-.006.021Zm2.76-.063-.007,0a.015.015,0,0,1-.006-.021l.019-.038a.015.015,0,0,1,.02-.007.015.015,0,0,1,.007.02l-.019.039A.016.016,0,0,1,4603.529-919.918Zm-2.8-.013a.016.016,0,0,1-.014-.009l-.018-.039a.015.015,0,0,1,.007-.02.015.015,0,0,1,.02.008l.019.038a.015.015,0,0,1-.007.02Zm2.836-.065h-.006a.015.015,0,0,1-.008-.02c.005-.013.011-.026.016-.039a.016.016,0,0,1,.02-.008.015.015,0,0,1,.008.02l-.017.04A.015.015,0,0,1,4603.566-920Zm-2.872-.012a.015.015,0,0,1-.014-.009l-.017-.04a.016.016,0,0,1,.009-.02.016.016,0,0,1,.02.009l.016.039a.015.015,0,0,1-.008.02Zm2.9-.067h-.005a.015.015,0,0,1-.009-.02l.014-.04a.015.015,0,0,1,.02-.01.015.015,0,0,1,.009.019l-.014.041A.016.016,0,0,1,4603.6-920.075Zm-2.936-.012a.016.016,0,0,1-.014-.01l-.014-.041a.015.015,0,0,1,.01-.019.015.015,0,0,1,.019.01l.014.04a.015.015,0,0,1-.009.02Zm2.964-.069h0a.015.015,0,0,1-.01-.019c0-.013.008-.027.012-.041a.015.015,0,0,1,.019-.011.015.015,0,0,1,.011.019c0,.014-.008.028-.012.041A.015.015,0,0,1,4603.626-920.157Zm-2.991-.012a.015.015,0,0,1-.015-.011c0-.014-.008-.028-.012-.042a.015.015,0,0,1,.011-.019.015.015,0,0,1,.019.011l.012.041a.015.015,0,0,1-.01.019Zm3.014-.07h0a.015.015,0,0,1-.011-.019c0-.014.007-.028.01-.041a.015.015,0,0,1,.018-.012.015.015,0,0,1,.012.018c0,.014-.006.028-.01.042A.016.016,0,0,1,4603.649-920.239Zm-3.036-.013a.015.015,0,0,1-.015-.012c0-.014-.007-.028-.01-.042a.015.015,0,0,1,.012-.018.015.015,0,0,1,.018.012c0,.014.006.028.01.041a.016.016,0,0,1-.011.018Zm3.055-.071h0a.015.015,0,0,1-.012-.018l.007-.042a.015.015,0,0,1,.018-.013.016.016,0,0,1,.013.018c0,.014,0,.029-.008.043A.015.015,0,0,1,4603.667-920.323Zm-3.072-.013a.015.015,0,0,1-.015-.013c0-.014,0-.028-.007-.043a.015.015,0,0,1,.013-.017.015.015,0,0,1,.018.013c0,.014,0,.028.007.042a.015.015,0,0,1-.012.018Zm3.086-.072h0a.015.015,0,0,1-.013-.017c0-.014,0-.028,0-.042a.016.016,0,0,1,.017-.014.015.015,0,0,1,.014.017c0,.014,0,.029-.005.043A.015.015,0,0,1,4603.682-920.407Zm-3.1-.013a.016.016,0,0,1-.016-.013c0-.014,0-.029,0-.043a.016.016,0,0,1,.014-.017.015.015,0,0,1,.017.014c0,.014,0,.028,0,.042a.015.015,0,0,1-.013.017Zm3.109-.072h0a.015.015,0,0,1-.014-.016c0-.014,0-.028,0-.042a.015.015,0,0,1,.016-.014.015.015,0,0,1,.015.016l0,.043A.015.015,0,0,1,4603.691-920.493Zm-3.118-.013a.015.015,0,0,1-.015-.014c0-.014,0-.029,0-.043a.015.015,0,0,1,.014-.016.015.015,0,0,1,.016.015c0,.014,0,.028,0,.042a.015.015,0,0,1-.014.016Zm3.122-.073h0a.015.015,0,0,1-.015-.016c0-.014,0-.028,0-.042a.016.016,0,0,1,0-.008.016.016,0,0,1,0-.008c0-.014,0-.028,0-.042a.015.015,0,0,1,.015-.016.015.015,0,0,1,.016.015c0,.014,0,.029,0,.043a.017.017,0,0,1,0,.009.016.016,0,0,1,0,.008c0,.014,0,.029,0,.043A.016.016,0,0,1,4603.7-920.578Zm-3.126-.013a.015.015,0,0,1-.015-.015c0-.01,0-.02,0-.03v-.013a.015.015,0,0,1,.016-.015.015.015,0,0,1,.015.015v.042a.015.015,0,0,1-.015.016Zm0-.086h0a.016.016,0,0,1-.015-.016c0-.014,0-.029,0-.043a.016.016,0,0,1,.017-.014.015.015,0,0,1,.014.016c0,.014,0,.028,0,.042A.016.016,0,0,1,4600.57-920.677Zm3.123-.047a.015.015,0,0,1-.016-.014c0-.014,0-.028,0-.042a.015.015,0,0,1,.014-.017.015.015,0,0,1,.017.014c0,.014,0,.029,0,.043a.015.015,0,0,1-.014.016Zm-3.118-.039h0a.015.015,0,0,1-.014-.017l0-.043a.015.015,0,0,1,.017-.013.015.015,0,0,1,.013.017c0,.014,0,.028,0,.042A.016.016,0,0,1,4600.575-920.762Zm3.11-.047a.015.015,0,0,1-.015-.013l-.006-.042a.015.015,0,0,1,.013-.017.015.015,0,0,1,.018.013l.006.043a.015.015,0,0,1-.014.017Zm-3.1-.039h0a.015.015,0,0,1-.013-.017c0-.014,0-.029.007-.043a.015.015,0,0,1,.018-.012.015.015,0,0,1,.012.018c0,.014,0,.028-.006.042A.015.015,0,0,1,4600.585-920.847Zm3.087-.046a.015.015,0,0,1-.015-.013c0-.014,0-.028-.008-.042a.015.015,0,0,1,.012-.018.015.015,0,0,1,.018.012c0,.014.006.028.008.042a.015.015,0,0,1-.013.018Zm-3.072-.038h0a.016.016,0,0,1-.012-.018c0-.014.006-.028.009-.042a.015.015,0,0,1,.018-.012.015.015,0,0,1,.012.018c0,.014-.006.028-.009.041A.015.015,0,0,1,4600.6-920.932Zm3.055-.046a.016.016,0,0,1-.015-.012c0-.014-.006-.028-.01-.041a.016.016,0,0,1,.011-.019.015.015,0,0,1,.019.011c0,.014.007.028.01.042a.015.015,0,0,1-.011.018Zm-3.036-.038h0a.015.015,0,0,1-.011-.019c0-.014.007-.028.011-.042a.015.015,0,0,1,.019-.01.015.015,0,0,1,.01.019l-.011.041A.015.015,0,0,1,4600.619-921.015Zm3.014-.045a.016.016,0,0,1-.015-.011c0-.014-.008-.027-.012-.041a.015.015,0,0,1,.01-.019.016.016,0,0,1,.02.01l.013.041a.016.016,0,0,1-.011.019Zm-2.99-.037h0a.016.016,0,0,1-.01-.019c0-.014.009-.028.014-.041a.015.015,0,0,1,.02-.009.015.015,0,0,1,.009.019l-.013.04A.016.016,0,0,1,4600.643-921.1Zm2.964-.044a.016.016,0,0,1-.015-.01l-.015-.04a.015.015,0,0,1,.009-.02.015.015,0,0,1,.02.009l.015.041a.015.015,0,0,1-.009.02Zm-2.936-.037h-.005a.015.015,0,0,1-.009-.02c0-.013.01-.027.016-.04a.015.015,0,0,1,.02-.008.015.015,0,0,1,.008.02l-.016.04A.015.015,0,0,1,4600.671-921.178Zm2.905-.043a.015.015,0,0,1-.014-.009l-.017-.039a.015.015,0,0,1,.007-.02.016.016,0,0,1,.021.008l.017.04a.016.016,0,0,1-.008.02Zm-2.873-.036h-.006a.015.015,0,0,1-.008-.02l.018-.039a.015.015,0,0,1,.021-.007.016.016,0,0,1,.007.02l-.018.039A.015.015,0,0,1,4600.7-921.258Zm2.837-.042a.015.015,0,0,1-.014-.009l-.019-.038a.015.015,0,0,1,.007-.021.015.015,0,0,1,.021.007c.006.013.013.026.019.039a.015.015,0,0,1-.007.02Zm-2.8-.036-.007,0a.016.016,0,0,1-.007-.021l.021-.038a.016.016,0,0,1,.021-.006.015.015,0,0,1,.006.021l-.02.038A.015.015,0,0,1,4600.741-921.335Zm2.761-.04a.016.016,0,0,1-.014-.008c-.006-.012-.014-.025-.021-.037a.016.016,0,0,1,.006-.021.015.015,0,0,1,.021.005l.021.038a.015.015,0,0,1-.006.021Zm-2.72-.035-.008,0a.015.015,0,0,1-.005-.021l.022-.037a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.022.036A.015.015,0,0,1,4600.783-921.41Zm2.676-.039a.015.015,0,0,1-.013-.007l-.023-.036a.015.015,0,0,1,0-.021.016.016,0,0,1,.021,0l.023.036a.016.016,0,0,1,0,.021Zm-2.631-.034-.008,0a.015.015,0,0,1,0-.021l.024-.036a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.024.035A.015.015,0,0,1,4600.828-921.483Zm2.583-.037a.015.015,0,0,1-.012-.007l-.025-.034a.015.015,0,0,1,0-.021.015.015,0,0,1,.021,0l.025.035a.015.015,0,0,1,0,.021A.015.015,0,0,1,4603.412-921.52Zm-2.534-.033a.016.016,0,0,1-.009,0,.015.015,0,0,1,0-.021l.026-.034a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.026.034A.015.015,0,0,1,4600.877-921.553Zm2.483-.035a.015.015,0,0,1-.012-.006l-.027-.033a.015.015,0,0,1,0-.022.015.015,0,0,1,.021,0l.027.034a.015.015,0,0,1,0,.021A.016.016,0,0,1,4603.36-921.589Zm-2.43-.032a.015.015,0,0,1-.01,0,.015.015,0,0,1,0-.022l.028-.033a.015.015,0,0,1,.021,0,.016.016,0,0,1,0,.022l-.027.032A.017.017,0,0,1,4600.93-921.621Zm2.375-.034a.014.014,0,0,1-.011-.005l-.029-.031a.015.015,0,0,1,0-.022.015.015,0,0,1,.021,0l.029.032a.016.016,0,0,1,0,.022A.015.015,0,0,1,4603.306-921.654Zm-2.319-.031a.015.015,0,0,1-.01,0,.015.015,0,0,1,0-.022l.03-.031a.015.015,0,0,1,.021,0,.016.016,0,0,1,0,.022l-.029.031A.015.015,0,0,1,4600.987-921.685Zm2.261-.032a.015.015,0,0,1-.011,0l-.03-.03a.015.015,0,0,1,0-.022.015.015,0,0,1,.021,0l.031.03a.016.016,0,0,1,0,.022A.015.015,0,0,1,4603.248-921.717Zm-2.2-.029a.015.015,0,0,1-.011,0,.015.015,0,0,1,0-.022l.032-.03a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.022l-.031.029A.015.015,0,0,1,4601.047-921.746Zm2.139-.03a.016.016,0,0,1-.01,0l-.032-.028a.016.016,0,0,1,0-.022.015.015,0,0,1,.021,0l.032.029a.016.016,0,0,1,0,.022A.016.016,0,0,1,4603.186-921.776Zm-2.075-.027a.015.015,0,0,1-.012-.005.016.016,0,0,1,0-.022l.033-.028a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.033.027A.015.015,0,0,1,4601.11-921.8Zm2.01-.029a.013.013,0,0,1-.009,0l-.033-.026a.015.015,0,0,1,0-.021.015.015,0,0,1,.021,0l.034.027a.015.015,0,0,1,0,.022A.016.016,0,0,1,4603.121-921.832Zm-1.944-.026a.016.016,0,0,1-.012-.006.015.015,0,0,1,0-.021l.035-.026a.015.015,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.034.025A.014.014,0,0,1,4601.176-921.858Zm1.876-.027-.009,0-.035-.025a.015.015,0,0,1,0-.021.015.015,0,0,1,.021,0l.035.025a.015.015,0,0,1,0,.021A.016.016,0,0,1,4603.053-921.885Zm-1.807-.024a.015.015,0,0,1-.013-.007.015.015,0,0,1,0-.021l.036-.024a.016.016,0,0,1,.021,0,.015.015,0,0,1,0,.021l-.035.024Zm1.737-.025-.008,0-.036-.023a.015.015,0,0,1,0-.021.015.015,0,0,1,.021-.005l.037.023a.015.015,0,0,1,0,.021A.015.015,0,0,1,4602.982-921.933Zm-1.665-.022a.015.015,0,0,1-.013-.007.015.015,0,0,1,0-.021l.037-.022a.015.015,0,0,1,.021.006.015.015,0,0,1-.006.021l-.036.022Zm1.592-.023-.008,0-.037-.021a.015.015,0,0,1-.006-.021.015.015,0,0,1,.021-.006l.038.021a.015.015,0,0,1,.005.021A.015.015,0,0,1,4602.909-921.978Zm-1.518-.02a.015.015,0,0,1-.013-.008.015.015,0,0,1,.006-.021l.039-.02a.015.015,0,0,1,.021.007.016.016,0,0,1-.007.021l-.038.02Zm1.442-.021-.007,0-.038-.019a.015.015,0,0,1-.007-.02.015.015,0,0,1,.02-.007l.039.019a.015.015,0,0,1,.007.021A.015.015,0,0,1,4602.833-922.019Zm-1.366-.018a.015.015,0,0,1-.014-.009.015.015,0,0,1,.007-.02l.039-.018a.016.016,0,0,1,.021.008.016.016,0,0,1-.008.02l-.039.017Zm1.289-.019h-.006l-.04-.016a.015.015,0,0,1-.008-.02.015.015,0,0,1,.02-.008l.04.017a.015.015,0,0,1,.008.02A.015.015,0,0,1,4602.756-922.055Zm-1.21-.015a.015.015,0,0,1-.014-.01.015.015,0,0,1,.008-.02l.04-.016a.016.016,0,0,1,.02.009.016.016,0,0,1-.009.02l-.04.015Zm1.13-.017h-.005l-.04-.014a.015.015,0,0,1-.01-.019.016.016,0,0,1,.02-.01l.041.015a.015.015,0,0,1,.009.02A.015.015,0,0,1,4602.676-922.087Zm-1.05-.013a.016.016,0,0,1-.015-.01.015.015,0,0,1,.01-.019l.041-.013a.015.015,0,0,1,.019.01.015.015,0,0,1-.01.019l-.041.013Zm.969-.014h0l-.041-.012a.015.015,0,0,1-.011-.019.015.015,0,0,1,.019-.011l.042.012a.015.015,0,0,1,.01.019A.015.015,0,0,1,4602.595-922.115Zm-.887-.011a.016.016,0,0,1-.015-.011.015.015,0,0,1,.011-.019l.042-.011a.015.015,0,0,1,.019.011.015.015,0,0,1-.011.019l-.041.011Zm.8-.012h0l-.042-.01a.016.016,0,0,1-.012-.018.015.015,0,0,1,.018-.012l.042.01a.015.015,0,0,1,.011.019A.016.016,0,0,1,4602.512-922.138Zm-.722-.009a.015.015,0,0,1-.015-.012.015.015,0,0,1,.012-.018l.042-.009a.015.015,0,0,1,.018.012.016.016,0,0,1-.012.018l-.042.009Zm.638-.01h0l-.042-.007a.015.015,0,0,1-.012-.018.015.015,0,0,1,.018-.013l.042.008a.015.015,0,0,1,.012.018A.015.015,0,0,1,4602.429-922.156Zm-.554-.007a.015.015,0,0,1-.015-.013.015.015,0,0,1,.012-.018l.043-.006a.015.015,0,0,1,.017.013.015.015,0,0,1-.013.017l-.042.006Zm.469-.007h0l-.042-.005a.015.015,0,0,1-.013-.017.015.015,0,0,1,.017-.014l.043.005a.016.016,0,0,1,.013.017A.015.015,0,0,1,4602.344-922.17Zm-.385,0a.016.016,0,0,1-.015-.014.015.015,0,0,1,.014-.017l.043,0a.016.016,0,0,1,.017.014.016.016,0,0,1-.014.016l-.042,0Zm.3,0h0l-.042,0a.015.015,0,0,1-.014-.016.015.015,0,0,1,.016-.014l.043,0a.016.016,0,0,1,.014.016A.016.016,0,0,1,4602.259-922.179Zm-.214,0a.015.015,0,0,1-.015-.014.015.015,0,0,1,.014-.016l.043,0a.015.015,0,0,1,.016.015.015.015,0,0,1-.015.016l-.042,0Zm.128,0h-.042a.015.015,0,0,1-.016-.015.015.015,0,0,1,.016-.015h.043a.016.016,0,0,1,.015.016A.016.016,0,0,1,4602.173-922.184Z",
    transform: "translate(-4600.246 922.523)",
    fill: "#fff",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42195",
    "data-name": "Group 42195",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 1.334,
    cy: 1.334,
    r: 1.334,
    transform: "translate(0 1.887) rotate(-45)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82490",
    "data-name": "Path 82490",
    d: "M4635.69-885.712a1.356,1.356,0,0,1-.965-.4,1.356,1.356,0,0,1-.4-.965,1.356,1.356,0,0,1,.4-.965,1.356,1.356,0,0,1,.965-.4,1.356,1.356,0,0,1,.965.4,1.356,1.356,0,0,1,.4.965,1.356,1.356,0,0,1-.4.965A1.356,1.356,0,0,1,4635.69-885.712Zm0-2.669a1.305,1.305,0,0,0-1.3,1.3,1.305,1.305,0,0,0,1.3,1.3,1.305,1.305,0,0,0,1.3-1.3A1.305,1.305,0,0,0,4635.69-888.381Z",
    transform: "translate(-4633.803 888.964)",
    fill: "#fff",
    opacity: 0.83
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42196",
    "data-name": "Group 42196",
    transform: "translate(0.737 0.737)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 0.813,
    cy: 0.813,
    r: 0.813,
    transform: "translate(0 1.15) rotate(-45)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82491",
    "data-name": "Path 82491",
    d: "M4717.445-804.479a.845.845,0,0,1-.844-.844.845.845,0,0,1,.844-.844.845.845,0,0,1,.844.844A.845.845,0,0,1,4717.445-804.479Zm0-1.627a.784.784,0,0,0-.783.783.784.784,0,0,0,.783.783.784.784,0,0,0,.783-.783A.784.784,0,0,0,4717.445-806.106Z",
    transform: "translate(-4716.294 806.473)",
    fill: "#fff",
    opacity: 0.83
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42197",
    "data-name": "Group 42197",
    transform: "translate(1.507 1.507)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 0.315,
    cy: 0.315,
    r: 0.315,
    transform: "translate(0 0.613) rotate(-76.572)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82492",
    "data-name": "Path 82492",
    d: "M4795.659-726.762a.346.346,0,0,1-.346-.346.346.346,0,0,1,.346-.346.346.346,0,0,1,.346.346A.346.346,0,0,1,4795.659-726.762Zm0-.63a.285.285,0,0,0-.285.285.285.285,0,0,0,.285.285.285.285,0,0,0,.285-.285A.285.285,0,0,0,4795.659-727.393Z",
    transform: "translate(-4795.279 727.488)",
    fill: "#fff",
    opacity: 0.83
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42199",
    "data-name": "Group 42199",
    transform: "translate(1.881)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22861",
    "data-name": "Rectangle 22861",
    width: 0.06,
    height: 2.257,
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 0.348, 1.852)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82493",
    "data-name": "Path 82493",
    d: "M4849.241-737.546c.024-.024.138.09.114.114l-.422.332a.017.017,0,0,1-.024-.024Z",
    transform: "translate(-4848.905 739.254)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82494",
    "data-name": "Path 82494",
    d: "M5085.636-966.2l.215.021-.295.295a.455.455,0,0,1-.367.131Z",
    transform: "translate(-5083.692 966.46)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82495",
    "data-name": "Path 82495",
    d: "M5078.628-1006.551l-.021-.215-.295.295a.456.456,0,0,0-.131.367Z",
    transform: "translate(-5076.727 1006.766)",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42204",
    "data-name": "Group 42204",
    transform: "translate(3097.696 -1002.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82496",
    "data-name": "Path 82496",
    d: "M3366.421-379.9l-.13.019a.57.57,0,0,0-.142-.119l0-.131a.011.011,0,0,0-.008-.01l-.15-.047a.011.011,0,0,0-.012,0l-.078.105a.571.571,0,0,0-.184.016l-.1-.09a.011.011,0,0,0-.012,0l-.139.073a.011.011,0,0,0-.006.011l.02.13a.57.57,0,0,0-.119.142l-.131,0a.011.011,0,0,0-.01.008l-.047.15a.01.01,0,0,0,0,.012l.105.078a.576.576,0,0,0,.016.185l-.09.1a.011.011,0,0,0,0,.012l.073.14a.011.011,0,0,0,.011.006l.13-.019a.573.573,0,0,0,.142.119l0,.131a.011.011,0,0,0,.008.01l.15.047a.011.011,0,0,0,.012,0l.078-.105a.571.571,0,0,0,.185-.016l.1.09a.011.011,0,0,0,.012,0l.14-.073a.011.011,0,0,0,.006-.011l-.019-.13a.569.569,0,0,0,.119-.142l.131,0a.011.011,0,0,0,.01-.008l.047-.15a.011.011,0,0,0,0-.012l-.105-.078a.562.562,0,0,0-.016-.185l.09-.1a.011.011,0,0,0,0-.012l-.073-.14A.011.011,0,0,0,3366.421-379.9Z",
    transform: "translate(-3364.999 380.357)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42201",
    "data-name": "Group 42201",
    transform: "translate(0.704 0.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82497",
    "data-name": "Path 82497",
    d: "M3449.284-296.087a.153.153,0,0,1-.124.052.153.153,0,0,1-.144-.161.153.153,0,0,1,.161-.144.153.153,0,0,1,.144.161A.151.151,0,0,1,3449.284-296.087Zm-.21-.184a.126.126,0,0,0-.031.076.127.127,0,0,0,.119.134.127.127,0,0,0,.134-.119.126.126,0,0,0-.032-.092.127.127,0,0,0-.087-.042.126.126,0,0,0-.092.032Z",
    transform: "translate(-3449.017 296.34)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42202",
    "data-name": "Group 42202",
    transform: "translate(0.37 0.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82498",
    "data-name": "Path 82498",
    d: "M3598.64-313.175l-.007,0a.013.013,0,0,1-.016-.01c0-.016-.008-.033-.013-.049a.013.013,0,0,1,.009-.016.013.013,0,0,1,.016.009c.005.017.01.034.014.051A.012.012,0,0,1,3598.64-313.175Z",
    transform: "translate(-3597.323 313.246)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82499",
    "data-name": "Path 82499",
    d: "M3427.144-279.706a.013.013,0,0,1-.018,0,.013.013,0,0,1,0-.018.865.865,0,0,0,.057-.079.013.013,0,0,1,.018,0,.013.013,0,0,1,0,.018.91.91,0,0,1-.059.081Zm-.113.114h0a.838.838,0,0,1-.08.06.013.013,0,0,1-.018,0,.013.013,0,0,1,0-.018.872.872,0,0,0,.078-.058.013.013,0,0,1,.018,0A.013.013,0,0,1,3427.031-279.592Zm.244-.336a.013.013,0,0,1-.014,0,.013.013,0,0,1-.007-.017.821.821,0,0,0,.031-.092.013.013,0,0,1,.016-.009.013.013,0,0,1,.009.016.821.821,0,0,1-.031.1Zm-.465.469,0,0a.851.851,0,0,1-.095.032.013.013,0,0,1-.016-.009.013.013,0,0,1,.009-.016.841.841,0,0,0,.092-.031.013.013,0,0,1,.017.007A.013.013,0,0,1,3426.81-279.459Zm.523-.721a.012.012,0,0,1-.01,0,.013.013,0,0,1-.012-.014v-.012c0-.028,0-.057,0-.086a.013.013,0,0,1,.012-.013.013.013,0,0,1,.013.012c0,.029,0,.059,0,.088v.012A.014.014,0,0,1,3427.333-280.18Zm-.774.781a.013.013,0,0,1-.009,0,.868.868,0,0,1-.1,0,.013.013,0,0,1-.012-.013.013.013,0,0,1,.013-.012.84.84,0,0,0,.1,0,.013.013,0,0,1,.014.012A.013.013,0,0,1,3426.559-279.4Zm-.258-.019a.013.013,0,0,1-.013,0,.855.855,0,0,1-.1-.028.013.013,0,0,1-.008-.017.013.013,0,0,1,.017-.008.829.829,0,0,0,.093.027.013.013,0,0,1,.01.015Z",
    transform: "translate(-3425.995 280.509)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82500",
    "data-name": "Path 82500",
    d: "M3396.376-163.79a.013.013,0,0,1-.016,0l-.044-.028a.013.013,0,0,1,0-.018.013.013,0,0,1,.018,0l.043.027a.013.013,0,0,1,0,.018Z",
    transform: "translate(-3396.31 164.785)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42203",
    "data-name": "Group 42203",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82501",
    "data-name": "Path 82501",
    d: "M3339.285-254.1a.013.013,0,0,1-.007,0,.013.013,0,0,1-.015-.01c0-.017-.007-.034-.01-.052a.013.013,0,0,1,.011-.015.013.013,0,0,1,.015.011c0,.017.005.034.009.05A.012.012,0,0,1,3339.285-254.1Z",
    transform: "translate(-3339.245 255.144)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82502",
    "data-name": "Path 82502",
    d: "M3339.039-407.474a.013.013,0,0,1-.015,0,.816.816,0,0,0-.09-.031.013.013,0,0,1-.009-.016.013.013,0,0,1,.016-.009.85.85,0,0,1,.093.032.013.013,0,0,1,.007.017Zm-.247-.061a.013.013,0,0,1-.011,0l-.027,0h-.068a.013.013,0,0,1-.013-.013.013.013,0,0,1,.012-.013h.07l.028,0a.013.013,0,0,1,.012.014A.013.013,0,0,1,3338.792-407.535Zm-.92.81a.013.013,0,0,1-.01,0,.013.013,0,0,1-.012-.013v-.018c0-.027,0-.053.008-.08a.013.013,0,0,1,.015-.011.013.013,0,0,1,.011.015c0,.025-.007.051-.008.077v.018A.015.015,0,0,1,3337.873-406.725Zm.666-.8a.012.012,0,0,1-.007,0,.828.828,0,0,0-.092.025.013.013,0,0,1-.016-.008.013.013,0,0,1,.008-.016.848.848,0,0,1,.095-.026.013.013,0,0,1,.015.01A.012.012,0,0,1,3338.539-407.52Zm-.619.545a.013.013,0,0,1-.014,0,.013.013,0,0,1-.008-.016.814.814,0,0,1,.038-.091.013.013,0,0,1,.017-.006.013.013,0,0,1,.006.017.87.87,0,0,0-.037.088Zm.382-.455,0,0a.857.857,0,0,0-.081.052.013.013,0,0,1-.018,0,.013.013,0,0,1,0-.018.866.866,0,0,1,.083-.053.013.013,0,0,1,.018,0A.013.013,0,0,1,3338.3-407.429Zm-.262.231a.013.013,0,0,1-.018,0,.013.013,0,0,1,0-.018c.013-.018.028-.036.042-.053h0l.021-.023a.013.013,0,0,1,.018,0,.013.013,0,0,1,0,.018l-.02.022c-.014.016-.028.034-.042.051Z",
    transform: "translate(-3337.85 407.56)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82503",
    "data-name": "Path 82503",
    d: "M3544.27-385.693a.013.013,0,0,1-.017,0l-.042-.029a.013.013,0,0,1,0-.018.013.013,0,0,1,.018,0l.043.03a.013.013,0,0,1,0,.018Z",
    transform: "translate(-3542.898 385.882)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82504",
    "data-name": "Path 82504",
    d: "M3411.326-333.337a.393.393,0,0,1-.414.116.393.393,0,0,1-.141-.079.394.394,0,0,1-.116-.414.393.393,0,0,1,.493-.257l.027.009a.4.4,0,0,1,.044.021l.006,0,0,0a.013.013,0,0,1,0,.016.013.013,0,0,1-.018,0,.372.372,0,0,0-.072-.031.368.368,0,0,0-.417.148.367.367,0,0,0-.041.084v.007a.368.368,0,0,0,.108.386.366.366,0,0,0,.132.074.367.367,0,0,0,.46-.24.366.366,0,0,0,.007-.2.013.013,0,0,1,.01-.016.013.013,0,0,1,.012,0,.012.012,0,0,1,0,.007.393.393,0,0,1-.007.209A.39.39,0,0,1,3411.326-333.337Z",
    transform: "translate(-3410.177 334.454)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42210",
    "data-name": "Group 42210",
    transform: "translate(3098.944 -1005.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42205",
    "data-name": "Group 42205"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22862",
    "data-name": "Rectangle 22862",
    width: 3.666,
    height: 3.811,
    rx: 1.833,
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22863",
    "data-name": "Rectangle 22863",
    width: 3.319,
    height: 3.598,
    rx: 1.66,
    transform: "translate(0.177 0.112)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22864",
    "data-name": "Rectangle 22864",
    width: 2.191,
    height: 0.228,
    rx: 0.114,
    transform: "translate(0.288 0.213)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42206",
    "data-name": "Group 42206",
    transform: "translate(2.587 0.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82505",
    "data-name": "Path 82505",
    d: "M3943.643-707.494a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,3943.643-707.494Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,3943.643-707.646Z",
    transform: "translate(-3943.55 707.67)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82506",
    "data-name": "Path 82506",
    d: "M3993.6-707.494a.091.091,0,0,1-.094-.088.091.091,0,0,1,.094-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,3993.6-707.494Zm0-.152a.066.066,0,0,0-.069.064.066.066,0,0,0,.069.064.066.066,0,0,0,.069-.064A.066.066,0,0,0,3993.6-707.646Z",
    transform: "translate(-3993.192 707.67)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82507",
    "data-name": "Path 82507",
    d: "M4043.56-707.494a.091.091,0,0,1-.094-.088.091.091,0,0,1,.094-.088.091.091,0,0,1,.093.088A.091.091,0,0,1,4043.56-707.494Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,4043.56-707.646Z",
    transform: "translate(-4042.834 707.67)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82508",
    "data-name": "Path 82508",
    d: "M3594.593-701.4h-1.944a.048.048,0,0,1-.048-.048.048.048,0,0,1,.048-.048h1.944a.048.048,0,0,1,.048.048A.048.048,0,0,1,3594.593-701.4Z",
    transform: "translate(-3592.236 701.781)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42207",
    "data-name": "Group 42207",
    transform: "translate(0.177 0.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82509",
    "data-name": "Path 82509",
    d: "M3563.09-675.2l-.22.224a.023.023,0,0,0,0,.033h0a.021.021,0,0,0,.03,0l.2-.243Z",
    transform: "translate(-3562.864 675.505)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_193",
    "data-name": "Ellipse 193",
    cx: 0.145,
    cy: 0.143,
    rx: 0.145,
    ry: 0.143,
    transform: "matrix(0.902, -0.431, 0.431, 0.902, 0.128, 0.125)",
    opacity: 0.2,
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82510",
    "data-name": "Path 82510",
    d: "M3588.12-718.792a.16.16,0,0,0-.078.213.16.16,0,0,0,.215.074.16.16,0,0,0,.078-.213A.16.16,0,0,0,3588.12-718.792Zm.127.266a.137.137,0,0,1-.183-.063.137.137,0,0,1,.066-.182.137.137,0,0,1,.183.063A.137.137,0,0,1,3588.247-718.526Z",
    transform: "translate(-3587.868 718.84)",
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22865",
    "data-name": "Rectangle 22865",
    width: 2.084,
    height: 1.187,
    rx: 0.594,
    transform: "translate(0.356 2.391)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42208",
    "data-name": "Group 42208",
    transform: "translate(0.475 2.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82511",
    "data-name": "Path 82511",
    d: "M3612.1-351.151h-1.8a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.8a.056.056,0,0,1,.056.056A.056.056,0,0,1,3612.1-351.151Z",
    transform: "translate(-3610.242 351.263)",
    opacity: 0.43,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82512",
    "data-name": "Path 82512",
    d: "M3611.835-317.318h-1.8a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.8a.056.056,0,0,1,.056.056A.056.056,0,0,1,3611.835-317.318Z",
    transform: "translate(-3609.982 317.644)",
    opacity: 0.43,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82513",
    "data-name": "Path 82513",
    d: "M3612.66-281.35h-1.8a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.8a.056.056,0,0,1,.056.056A.056.056,0,0,1,3612.66-281.35Z",
    transform: "translate(-3610.802 281.904)",
    opacity: 0.43,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82514",
    "data-name": "Path 82514",
    d: "M3612.4-247.518h-1.8a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.8a.056.056,0,0,1,.056.056A.056.056,0,0,1,3612.4-247.518Z",
    transform: "translate(-3610.541 248.286)",
    opacity: 0.43,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82515",
    "data-name": "Path 82515",
    d: "M3611.955-216.585h-1.8a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.8a.056.056,0,0,1,.056.056A.056.056,0,0,1,3611.955-216.585Z",
    transform: "translate(-3610.101 217.549)",
    opacity: 0.43,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22866",
    "data-name": "Rectangle 22866",
    width: 0.878,
    height: 1.191,
    rx: 0.439,
    transform: "translate(2.511 0.609)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22867",
    "data-name": "Rectangle 22867",
    width: 0.878,
    height: 1.673,
    rx: 0.439,
    transform: "translate(2.511 1.905)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82516",
    "data-name": "Path 82516",
    d: "M3610.525-397.534h-1.786a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.786a.056.056,0,0,1,.056.056A.056.056,0,0,1,3610.525-397.534Z",
    transform: "translate(-3608.216 399.851)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42209",
    "data-name": "Group 42209",
    transform: "translate(0.436 0.609)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22868",
    "data-name": "Rectangle 22868",
    width: 1.929,
    height: 1.499,
    rx: 0.75,
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82517",
    "data-name": "Path 82517",
    d: "M3644.883-590.734h1.2a.048.048,0,0,0,.042-.073l-.477-.811a.049.049,0,0,0-.086,0l-.23.5a.049.049,0,0,1-.077.016l-.093-.085a.048.048,0,0,0-.073.008l-.25.36A.048.048,0,0,0,3644.883-590.734Z",
    transform: "translate(-3644.575 592.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 0.173,
    cy: 0.173,
    r: 0.173,
    transform: "translate(1.27 0.273) rotate(-22.5)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42218",
    "data-name": "Group 42218",
    transform: "translate(3100.498 -1003.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42211",
    "data-name": "Group 42211",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22869",
    "data-name": "Rectangle 22869",
    width: 3.666,
    height: 3.811,
    rx: 1.833,
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22870",
    "data-name": "Rectangle 22870",
    width: 3.319,
    height: 3.598,
    rx: 1.66,
    transform: "translate(0.177 0.112)",
    fill: "#bdd0fb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22871",
    "data-name": "Rectangle 22871",
    width: 2.191,
    height: 0.228,
    rx: 0.114,
    transform: "translate(0.288 0.213)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42212",
    "data-name": "Group 42212",
    transform: "translate(2.587 0.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82518",
    "data-name": "Path 82518",
    d: "M4189.173-511.263a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,4189.173-511.263Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,4189.173-511.414Z",
    transform: "translate(-4189.08 511.439)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82519",
    "data-name": "Path 82519",
    d: "M4239.131-511.263a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,4239.131-511.263Zm0-.152a.066.066,0,0,0-.069.064.066.066,0,0,0,.069.064.066.066,0,0,0,.069-.064A.066.066,0,0,0,4239.131-511.414Z",
    transform: "translate(-4238.722 511.439)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82520",
    "data-name": "Path 82520",
    d: "M4289.089-511.263a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,4289.089-511.263Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,4289.089-511.414Z",
    transform: "translate(-4288.364 511.439)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82521",
    "data-name": "Path 82521",
    d: "M3840.122-505.173h-1.944a.048.048,0,0,1-.048-.048.048.048,0,0,1,.048-.048h1.944a.048.048,0,0,1,.048.048A.048.048,0,0,1,3840.122-505.173Z",
    transform: "translate(-3837.765 505.55)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42213",
    "data-name": "Group 42213",
    transform: "translate(0.177 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82522",
    "data-name": "Path 82522",
    d: "M3808.62-478.967l-.22.224a.023.023,0,0,0,0,.033h0a.021.021,0,0,0,.03,0l.2-.243Z",
    transform: "translate(-3808.394 479.243)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82523",
    "data-name": "Path 82523",
    d: "M3836.415-519.943a.144.144,0,0,1-.07.192.144.144,0,0,1-.193-.066.144.144,0,0,1,.07-.192A.144.144,0,0,1,3836.415-519.943Z",
    transform: "translate(-3835.964 520.04)",
    opacity: 0.2,
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82524",
    "data-name": "Path 82524",
    d: "M3833.65-522.561a.161.161,0,0,0-.078.213.161.161,0,0,0,.215.074.16.16,0,0,0,.078-.213A.16.16,0,0,0,3833.65-522.561Zm.127.266a.137.137,0,0,1-.183-.063.137.137,0,0,1,.066-.182.137.137,0,0,1,.183.063A.137.137,0,0,1,3833.777-522.3Z",
    transform: "translate(-3833.398 522.577)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82525",
    "data-name": "Path 82525",
    d: "M3874.23-397.534h-2.4a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h2.4a.056.056,0,0,1,.056.056A.056.056,0,0,1,3874.23-397.534Z",
    transform: "translate(-3871.191 398.608)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82526",
    "data-name": "Path 82526",
    d: "M3911.726-431.5h-1.879a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.879a.056.056,0,0,1,.056.056A.056.056,0,0,1,3911.726-431.5Z",
    transform: "translate(-3908.972 432.361)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42215",
    "data-name": "Group 42215",
    transform: "translate(0.352 1.221)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22872",
    "data-name": "Rectangle 22872",
    width: 1.42,
    height: 2.253,
    rx: 0.71,
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42214",
    "data-name": "Group 42214",
    transform: "translate(0.073 0.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82527",
    "data-name": "Path 82527",
    d: "M3849.082-339.913h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3849.082-339.913Z",
    transform: "translate(-3847.872 340.025)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82528",
    "data-name": "Path 82528",
    d: "M3848.908-306.08h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3848.908-306.08Z",
    transform: "translate(-3847.699 306.406)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82529",
    "data-name": "Path 82529",
    d: "M3849.455-270.112H3848.3a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3849.455-270.112Z",
    transform: "translate(-3848.243 270.666)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82530",
    "data-name": "Path 82530",
    d: "M3849.281-236.279h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3849.281-236.279Z",
    transform: "translate(-3848.07 237.047)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82531",
    "data-name": "Path 82531",
    d: "M3848.988-205.346h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3848.988-205.346Z",
    transform: "translate(-3847.779 206.31)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82532",
    "data-name": "Path 82532",
    d: "M3848.815-171.513h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3848.815-171.513Z",
    transform: "translate(-3847.607 172.691)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82533",
    "data-name": "Path 82533",
    d: "M3849.361-135.546h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3849.361-135.546Z",
    transform: "translate(-3848.15 136.952)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82534",
    "data-name": "Path 82534",
    d: "M3849.187-101.713h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3849.187-101.713Z",
    transform: "translate(-3847.977 103.333)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82535",
    "data-name": "Path 82535",
    d: "M3848.81-69.74h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3848.81-69.74Z",
    transform: "translate(-3847.601 71.562)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82536",
    "data-name": "Path 82536",
    d: "M3849.355-33.772H3848.2a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,3849.355-33.772Z",
    transform: "translate(-3848.144 35.822)",
    fill: "#bdd0fb",
    opacity: 0.43
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42217",
    "data-name": "Group 42217",
    transform: "translate(1.895 1.209)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22873",
    "data-name": "Rectangle 22873",
    width: 1.42,
    height: 2.253,
    rx: 0.71,
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42216",
    "data-name": "Group 42216",
    transform: "translate(0.073 0.106)",
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82537",
    "data-name": "Path 82537",
    d: "M4092.678-341.846h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.678-341.846Z",
    transform: "translate(-4091.468 341.958)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82538",
    "data-name": "Path 82538",
    d: "M4092.505-308.013h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.505-308.013Z",
    transform: "translate(-4091.297 308.339)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82539",
    "data-name": "Path 82539",
    d: "M4093.051-272.045H4091.9a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4093.051-272.045Z",
    transform: "translate(-4091.839 272.599)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82540",
    "data-name": "Path 82540",
    d: "M4092.878-238.212h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.878-238.212Z",
    transform: "translate(-4091.667 238.98)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82541",
    "data-name": "Path 82541",
    d: "M4092.585-207.28h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.585-207.28Z",
    transform: "translate(-4091.376 208.244)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82542",
    "data-name": "Path 82542",
    d: "M4092.411-173.447h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.411-173.447Z",
    transform: "translate(-4091.203 174.625)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82543",
    "data-name": "Path 82543",
    d: "M4092.957-137.479h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.957-137.479Z",
    transform: "translate(-4091.746 138.885)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82544",
    "data-name": "Path 82544",
    d: "M4092.784-103.646h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.784-103.646Z",
    transform: "translate(-4091.574 105.266)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82545",
    "data-name": "Path 82545",
    d: "M4092.406-71.674h-1.152a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.406-71.674Z",
    transform: "translate(-4091.197 73.496)",
    fill: "#bdd0fb",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82546",
    "data-name": "Path 82546",
    d: "M4092.951-35.706H4091.8a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.152a.056.056,0,0,1,.056.056A.056.056,0,0,1,4092.951-35.706Z",
    transform: "translate(-4091.739 37.756)",
    fill: "#bdd0fb",
    opacity: 0.43
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42224",
    "data-name": "Group 42224",
    transform: "translate(3102.573 -1002.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42219",
    "data-name": "Group 42219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22874",
    "data-name": "Rectangle 22874",
    width: 3.666,
    height: 3.869,
    rx: 1.833,
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22875",
    "data-name": "Rectangle 22875",
    width: 3.319,
    height: 3.653,
    rx: 1.66,
    transform: "translate(0.177 0.113)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42223",
    "data-name": "Group 42223",
    transform: "translate(0.177 0.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42220",
    "data-name": "Group 42220",
    transform: "translate(0.244 0.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22876",
    "data-name": "Rectangle 22876",
    width: 1.929,
    height: 1.499,
    rx: 0.75,
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82547",
    "data-name": "Path 82547",
    d: "M4215.654-222.439h1.205a.048.048,0,0,0,.042-.073l-.477-.811a.049.049,0,0,0-.086,0l-.23.5a.049.049,0,0,1-.077.016l-.093-.085a.049.049,0,0,0-.073.008l-.25.36A.048.048,0,0,0,4215.654-222.439Z",
    transform: "translate(-4215.347 223.714)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 0.173,
    cy: 0.173,
    r: 0.173,
    transform: "translate(1.27 0.273) rotate(-22.5)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22877",
    "data-name": "Rectangle 22877",
    width: 2.191,
    height: 0.228,
    rx: 0.114,
    transform: "translate(0.111 0.073)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42221",
    "data-name": "Group 42221",
    transform: "translate(2.41 0.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82548",
    "data-name": "Path 82548",
    d: "M4516.869-360.465a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,4516.869-360.465Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,4516.869-360.617Z",
    transform: "translate(-4516.775 360.641)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82549",
    "data-name": "Path 82549",
    d: "M4566.827-360.465a.091.091,0,0,1-.094-.088.091.091,0,0,1,.094-.088.091.091,0,0,1,.093.088A.091.091,0,0,1,4566.827-360.465Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,4566.827-360.617Z",
    transform: "translate(-4566.417 360.641)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82550",
    "data-name": "Path 82550",
    d: "M4616.785-360.465a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.093.088A.091.091,0,0,1,4616.785-360.465Zm0-.152a.066.066,0,0,0-.069.064.066.066,0,0,0,.069.064.066.066,0,0,0,.069-.064A.066.066,0,0,0,4616.785-360.617Z",
    transform: "translate(-4616.059 360.641)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82551",
    "data-name": "Path 82551",
    d: "M4167.818-354.375h-1.944a.048.048,0,0,1-.048-.048.048.048,0,0,1,.048-.048h1.944a.048.048,0,0,1,.048.048A.048.048,0,0,1,4167.818-354.375Z",
    transform: "translate(-4165.638 354.613)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42222",
    "data-name": "Group 42222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82552",
    "data-name": "Path 82552",
    d: "M4136.315-328.169l-.22.224a.023.023,0,0,0,0,.033h0a.021.021,0,0,0,.03,0l.2-.243Z",
    transform: "translate(-4136.089 328.477)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 0.145,
    cy: 0.143,
    rx: 0.145,
    ry: 0.143,
    transform: "matrix(0.902, -0.431, 0.431, 0.902, 0.128, 0.125)",
    opacity: 0.2,
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82553",
    "data-name": "Path 82553",
    d: "M4161.345-371.763a.161.161,0,0,0-.078.213.161.161,0,0,0,.215.074.161.161,0,0,0,.078-.213A.161.161,0,0,0,4161.345-371.763Zm.127.266a.137.137,0,0,1-.183-.063.137.137,0,0,1,.066-.182.137.137,0,0,1,.183.063A.137.137,0,0,1,4161.472-371.5Z",
    transform: "translate(-4161.093 371.811)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82554",
    "data-name": "Path 82554",
    d: "M4176.494-20.378h-1.817a.056.056,0,0,1-.056-.056.056.056,0,0,1,.056-.056h1.817a.056.056,0,0,1,.056.056A.056.056,0,0,1,4176.494-20.378Z",
    transform: "translate(-4174.377 22.746)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82555",
    "data-name": "Path 82555",
    d: "M4176.23,13.454h-1.817a.056.056,0,1,1,0-.112h1.817a.056.056,0,1,1,0,.112Z",
    transform: "translate(-4174.115 -10.872)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22878",
    "data-name": "Rectangle 22878",
    width: 1.929,
    height: 0.82,
    rx: 0.41,
    transform: "translate(0.242 2.699)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22879",
    "data-name": "Rectangle 22879",
    width: 0.923,
    height: 0.987,
    rx: 0.462,
    transform: "translate(2.294 0.604)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22880",
    "data-name": "Rectangle 22880",
    width: 0.923,
    height: 0.987,
    rx: 0.462,
    transform: "translate(2.294 1.816)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22881",
    "data-name": "Rectangle 22881",
    width: 0.923,
    height: 0.643,
    rx: 0.321,
    transform: "translate(2.294 2.876)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82556",
    "data-name": "Path 82556",
    d: "M4499.338-115.7h-.828a.048.048,0,0,1-.048-.048.048.048,0,0,1,.048-.048h.828a.048.048,0,0,1,.047.048A.048.048,0,0,1,4499.338-115.7Z",
    transform: "translate(-4496.168 117.449)",
    fill: "#fff",
    opacity: 0.43
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42231",
    "data-name": "Group 42231",
    transform: "translate(3104.935 -1001.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42225",
    "data-name": "Group 42225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22882",
    "data-name": "Rectangle 22882",
    width: 3.666,
    height: 3.869,
    rx: 1.833,
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22883",
    "data-name": "Rectangle 22883",
    width: 3.319,
    height: 3.653,
    rx: 1.66,
    transform: "translate(0.177 0.113)",
    fill: "#bdd0fb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22884",
    "data-name": "Rectangle 22884",
    width: 2.657,
    height: 1.499,
    rx: 0.75,
    transform: "translate(0.525 0.744)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22885",
    "data-name": "Rectangle 22885",
    width: 2.191,
    height: 0.228,
    rx: 0.114,
    transform: "translate(0.288 0.213)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42226",
    "data-name": "Group 42226",
    transform: "translate(2.587 0.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82557",
    "data-name": "Path 82557",
    d: "M4890-173.9a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.093.088A.091.091,0,0,1,4890-173.9Zm0-.152a.066.066,0,0,0-.069.064.066.066,0,0,0,.069.064.066.066,0,0,0,.069-.064A.066.066,0,0,0,4890-174.053Z",
    transform: "translate(-4889.903 174.077)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82558",
    "data-name": "Path 82558",
    d: "M4939.954-173.9a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,4939.954-173.9Zm0-.152a.066.066,0,0,0-.069.064.066.066,0,0,0,.069.064.066.066,0,0,0,.069-.064A.066.066,0,0,0,4939.954-174.053Z",
    transform: "translate(-4939.544 174.077)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82559",
    "data-name": "Path 82559",
    d: "M4989.912-173.9a.091.091,0,0,1-.093-.088.091.091,0,0,1,.093-.088.091.091,0,0,1,.094.088A.091.091,0,0,1,4989.912-173.9Zm0-.152a.067.067,0,0,0-.069.064.067.067,0,0,0,.069.064.067.067,0,0,0,.069-.064A.067.067,0,0,0,4989.912-174.053Z",
    transform: "translate(-4989.187 174.077)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82560",
    "data-name": "Path 82560",
    d: "M4540.946-167.811H4539a.048.048,0,0,1-.048-.048.048.048,0,0,1,.048-.048h1.944a.048.048,0,0,1,.048.048A.048.048,0,0,1,4540.946-167.811Z",
    transform: "translate(-4538.589 168.188)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42227",
    "data-name": "Group 42227",
    transform: "translate(0.177 0.171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82561",
    "data-name": "Path 82561",
    d: "M4509.444-141.6l-.22.224a.022.022,0,0,0,0,.033h0a.021.021,0,0,0,.03,0l.2-.243Z",
    transform: "translate(-4509.217 141.881)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82562",
    "data-name": "Path 82562",
    d: "M4537.24-182.582a.145.145,0,0,1-.07.192.144.144,0,0,1-.193-.066.145.145,0,0,1,.07-.192A.144.144,0,0,1,4537.24-182.582Z",
    transform: "translate(-4536.788 182.678)",
    opacity: 0.2,
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82563",
    "data-name": "Path 82563",
    d: "M4534.474-185.2a.161.161,0,0,0-.078.213.161.161,0,0,0,.215.074.161.161,0,0,0,.078-.213A.161.161,0,0,0,4534.474-185.2Zm.127.266a.137.137,0,0,1-.183-.063.137.137,0,0,1,.066-.182.137.137,0,0,1,.183.063A.137.137,0,0,1,4534.6-184.933Z",
    transform: "translate(-4534.222 185.215)",
    fill: "url(#linear-gradient-63)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82564",
    "data-name": "Path 82564",
    d: "M4553.527,166.186h-2.7a.056.056,0,1,1,0-.112h2.7a.056.056,0,1,1,0,.112Z",
    transform: "translate(-4550.331 -163.679)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82565",
    "data-name": "Path 82565",
    d: "M4553.141,200.019h-2.7a.056.056,0,1,1,0-.112h2.7a.056.056,0,1,1,0,.112Z",
    transform: "translate(-4549.947 -197.297)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22886",
    "data-name": "Rectangle 22886",
    width: 1.929,
    height: 0.82,
    rx: 0.41,
    transform: "translate(0.346 2.838)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22887",
    "data-name": "Rectangle 22887",
    width: 0.923,
    height: 0.82,
    rx: 0.41,
    transform: "translate(2.397 2.838)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42230",
    "data-name": "Group 42230",
    transform: "translate(1.557 1.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42228",
    "data-name": "Group 42228",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82566",
    "data-name": "Path 82566",
    d: "M4727.924-26.065a.317.317,0,0,1-.317.317.316.316,0,0,1-.316-.317.316.316,0,0,1,.316-.317A.317.317,0,0,1,4727.924-26.065Zm-.02,0a.3.3,0,0,0-.3-.3.3.3,0,0,0-.3.3.3.3,0,0,0,.3.3A.3.3,0,0,0,4727.9-26.065Z",
    transform: "translate(-4727.291 26.382)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42229",
    "data-name": "Group 42229",
    transform: "translate(0.203 0.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82567",
    "data-name": "Path 82567",
    d: "M4759.352-1.391a.017.017,0,0,1-.017-.016l-.007-.28a.026.026,0,0,1,.012-.023.027.027,0,0,1,.026,0l.277.129a.026.026,0,0,1,.015.023.026.026,0,0,1-.014.024l-.245.13a.016.016,0,0,1-.022-.007.016.016,0,0,1,.006-.022l.233-.124-.256-.12.007.27a.017.017,0,0,1-.016.017Z",
    transform: "translate(-4759.328 1.715)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42233",
    "data-name": "Group 42233",
    transform: "translate(3099.487 -1004.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82568",
    "data-name": "Path 82568",
    d: "M3623.785-40.177l-2.918,2.8a.291.291,0,0,0,.008.427l.021.019a.27.27,0,0,0,.383-.023l2.687-3.048Z",
    transform: "translate(-3620.778 44.082)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 1.875,
    cy: 1.841,
    rx: 1.875,
    ry: 1.841,
    transform: "translate(1.812 1.512) rotate(-23.776)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82569",
    "data-name": "Path 82569",
    d: "M3967.875-595.95a2.068,2.068,0,0,0-1.083,2.716,2.068,2.068,0,0,0,2.735,1.034,2.067,2.067,0,0,0,1.083-2.716A2.067,2.067,0,0,0,3967.875-595.95Zm1.53,3.474a1.764,1.764,0,0,1-2.333-.882,1.764,1.764,0,0,1,.924-2.317,1.764,1.764,0,0,1,2.333.882A1.764,1.764,0,0,1,3969.405-592.476Z",
    transform: "translate(-3964.431 596.516)",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42232",
    "data-name": "Group 42232",
    transform: "translate(2.325 0.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82570",
    "data-name": "Path 82570",
    d: "M3988.305-572.068a.008.008,0,0,1-.008,0c-.025-.042-.049-.085-.071-.129a.008.008,0,0,1,0-.01.007.007,0,0,1,.01,0c.022.043.045.086.07.128a.008.008,0,0,1,0,.01Zm-.218-.53a.007.007,0,0,1-.009-.006,1.871,1.871,0,0,1-.052-.4,1.921,1.921,0,0,1,.3-1.073,1.965,1.965,0,0,1,.874-.751,1.97,1.97,0,0,1,1.079-.148.008.008,0,0,1,.006.008.008.008,0,0,1-.009.006,1.954,1.954,0,0,0-1.071.147,1.928,1.928,0,0,0-1.163,1.81,1.873,1.873,0,0,0,.052.393.008.008,0,0,1-.005.009Z",
    transform: "translate(-3988.026 574.993)",
    fill: "#bdd0fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_82571",
    "data-name": "Path 82571",
    d: "M3634.881,356.942h0a.225.225,0,0,1-.246-.108.219.219,0,0,1,.046-.251l.346-.347a.007.007,0,0,1,.01,0,.008.008,0,0,1,0,.011l-.346.347a.2.2,0,0,0-.043.234.211.211,0,0,0,.231.1.007.007,0,0,1,.008.007A.008.008,0,0,1,3634.881,356.942Z",
    transform: "translate(-3634.526 -349.82)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82572",
    "data-name": "Path 82572",
    d: "M3716.288,332.332a.008.008,0,0,1-.007,0,.008.008,0,0,1,0-.011l.045-.045a.007.007,0,0,1,.01,0,.008.008,0,0,1,0,.011l-.045.045Z",
    transform: "translate(-3715.675 -326.009)",
    fill: "#bdd0fb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseSearchBigImg);
export default __webpack_public_path__ + "static/media/Course Search Big Img.96155e37af50abae7c29eb8fac4e6a39.svg";
export { ForwardRef as ReactComponent };